module.exports = __webpack_public_path__ + "static/img/fabric_256.fb1857d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fabric_256.png
// module id = s+cp
// module chunks = 0